import styled from 'styled-components';
import { colors, darkModeBackground } from 'global/colors';

export const ExerciseProgressContainer = styled.div`
  padding: 5px;
  height: 100%;
  border-left: 1px solid ${({ isDarkMode }) => (isDarkMode ? darkModeBackground : colors.lightGray)};
  overflow-y: auto;
`;

export const ProgressHeader = styled.label`
  color: ${({ isDarkMode }) => (isDarkMode ? colors.fsCyan : colors.black)};
  font-size: 1rem;
  font-weight: 600;
`;

export const LevelRow = styled.span`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding-bottom: 0.5rem;
  color: ${({ isDarkMode }) => (isDarkMode ? colors.lightGray : colors.black)};
  cursor: ${({ unlocked }) => (unlocked ? 'pointer' : 'not-allowed')};
`;

const circleDiameter = 18;
export const LevelCircle = styled.span`
  position: relative;
  width: ${circleDiameter}px;
  height: ${circleDiameter}px;
  min-width: ${circleDiameter}px;
  min-height: ${circleDiameter}px;
  border-radius: 50%;
  text-align: center;
  line-height: 10px;
  border: 2px solid ${({ isDarkMode }) => (isDarkMode ? colors.lightGray : darkModeBackground)};
`;

const markDiameter = circleDiameter - 8;
export const CheckMark = styled.i`
  position: absolute;
  top: 2px;
  left: 2px;
  display: block;
  width: ${markDiameter}px;
  height: ${markDiameter}px;
  min-width: ${markDiameter}px;
  min-height: ${markDiameter}px;
  border-radius: 50%;
  background: ${({ isDarkMode }) => (isDarkMode ? colors.lightGray : darkModeBackground)};
`;

export const ProgressLine = styled.span`
  position: absolute;
  top: ${circleDiameter + 4}px;
  left: ${circleDiameter / 2 - 1}px;
  width: 2px;
  min-width: 2px;
  border-radius: 3px;
  min-height: calc(100% - ${circleDiameter + 8}px);
  background: ${({ isDarkMode }) => (isDarkMode ? colors.lightGray : darkModeBackground)};
`;

export const LevelLabel = styled.label`
  cursor: inherit;
  font-size: 0.8rem;
`;

export const HeaderIcon = styled.i.attrs(() => ({
  className: 'fa fa-trophy',
}))`
  font-size: 18px;
  margin-left: 1px;
  margin-right: 4px;
`;

export const LockIcon = styled.i.attrs(() => ({
  className: 'fa fa-lock',
}))`
  font-size: 14px;
  cursor: inherit;
`;
